import { App } from 'vue';

import { initCartLineKitDetails } from './cart-line-kit-details';
import { initCartSummary } from './cart-summary';
import { initGiftCollectionDisplay } from './gift-collection-display';
import { initHeaderCartIcon } from './header-cart-icon';
import { initMiniCart } from './mini-cart';
import type { ComponentState } from './shared';
import { initThresholdVisualizer } from './threshold-visualizer';

export { initCartLineKitDetails };

export type InitializationState = {
  // Main cart page (snippets/cart.liquid)
  thresholdVisualizer: ComponentState;
  giftCollectionDisplay: ComponentState;
  cartSummary: ComponentState;

  // Mini cart panel (snippets/mini-cart.liquid) — single root app
  miniCart: ComponentState;

  // Header
  headerCartIcon: ComponentState;
};

// Track mounted Vue app instances
export const mountedApps = new Map<string, App>();

// Track initialization state to prevent race conditions
export const initializationState: InitializationState = {
  // Main cart page
  thresholdVisualizer: { isInitializing: false, hasPendingRequest: false },
  giftCollectionDisplay: { isInitializing: false, hasPendingRequest: false },
  cartSummary: { isInitializing: false, hasPendingRequest: false },

  // Mini cart panel
  miniCart: { isInitializing: false, hasPendingRequest: false },

  // Header
  headerCartIcon: { isInitializing: false, hasPendingRequest: false }
};

// Main cart page mount selectors
export const thresholdVisualizerMountSelector =
  '.js-threshold-visualizer-mount';
export const giftCollectionDisplayMountSelector =
  '.js-gift-collection-display-mount';
export const cartSummaryMountSelector = '.js-cart-summary-mount';

// Mini cart panel mount selector (snippets/mini-cart.liquid)
export const miniCartMountSelector = '.js-mini-cart-mount';

// Header mount selector (snippets/header-cart.liquid)
export const headerCartIconMountSelector = '.js-header-cart-mount';

/**
 * Initialize all cart Vue components
 */
export const initAllCartComponents = async (
  waitForCartUpdate = false
): Promise<void> => {
  await Promise.all([
    // Main cart page
    initThresholdVisualizer(
      waitForCartUpdate,
      mountedApps,
      initializationState
    ),
    initGiftCollectionDisplay(
      waitForCartUpdate,
      mountedApps,
      initializationState
    ),
    initCartSummary(waitForCartUpdate, mountedApps, initializationState),
    initCartLineKitDetails(),

    // Mini cart panel
    initMiniCart(waitForCartUpdate, mountedApps, initializationState),

    // Header
    initHeaderCartIcon(waitForCartUpdate, mountedApps, initializationState)
  ]);
};
